import React from "react";
import GeneralSettingsIcon from "../../assets/icons/settings.svg2";
import BillingDetailsIcon from "../../assets/icons/invoice_history.svg2";
import SecuritySettingsIcon from "../../assets/icons/security.svg2";
import CustomersIcon from "../../assets/icons/customers.svg2";
import PageNavLinks from "../Common/PageNavLinks";
import GlobalSettingsIcon from "../../assets/icons/global_settings.svg2";
import AccountStatusIcon from "../../assets/icons/status.svg2";

export default function SettingsLinks() {
  return (
    <PageNavLinks
      pageName="settings"
      links={[
        {
          label: "COMMUNICATIONS",
          Icon: GeneralSettingsIcon,
          href: "/settings/communications",
        },
        {
          label: "BILLING ",
          Icon: BillingDetailsIcon,
          href: "/settings/billing",
        },
        {
          label: "SECURITY ",
          Icon: SecuritySettingsIcon,
          href: "/settings/security",
        },
        {
          label: "ORGANISATION",
          Icon: GlobalSettingsIcon,
          href: "/settings/organisation",
        },

        {
          label: "ACCOUNT OVERVIEW",
          Icon: AccountStatusIcon,
          href: "/settings/accountoverview",
        },
        {
          label: "USERS",
          Icon: CustomersIcon,
          href: "/settings/users",
        },
        {
          label: "SYSTEM ADMIN",
          Icon: CustomersIcon,
          href: "/settings/systemadmin",
        },
      ]}
    />
  );
}
